import * as React from "react";
import { formatValueOnPlanAndTotalType } from "../pinned-row-helpers";
import { IPlanMetricDoorRendererProps } from "./plan-metric-door-column";

export const TotalRow: React.FunctionComponent<IPlanMetricDoorRendererProps> = ({
    totalType,
    style,
    currency,
    total,
    planRowType,
}) => {
    const value = formatValueOnPlanAndTotalType({ value: total, totalType, currency, planRowType });

    return (
        <div style={style} className="planCell">
            <div className="actualValue">{value}</div>
        </div>
    );
};
